import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { OrderState } from '@/ApiClient';

export const useOrderStatuses = defineStore('order-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.orderStatus_GetOrderStatuses,
    dto: 'OrderStatusDto',
    create: api.orderStatus_AddOrderStatus,
    update: api.orderStatus_UpdateOrderStatus,
    delete: api.orderStatus_DeleteOrderStatus,
    usage: api.orderStatus_GetUsage,
    signalR: 'OrderStatusUpdate',
  });

  const { loaded } = globalStoreBase;

  function getStartingStatus() {
    return loaded.value.find((status) => status.state === OrderState.Planned);
  }

  return {
    ...globalStoreBase,
    getStartingStatus,
  };
});
